// eslint-disable-next-line import/no-extraneous-dependencies
import fileSize from 'filesize';
import React, { useEffect, useState } from 'react';
import { Box, Modal, Slide } from '@material-ui/core';
import { useToast } from '../../../../../../hooks/toast';
import { CustomCarousel } from '../../../../../../newComponents/custom-carousel';
import FileList from '../../../../../../newComponents/FileList';
import Load from '../../../../../../newComponents/Load';
import Upload from '../../../../../../newComponents/Upload';
import * as S from './styled';
import api from '../../../../../../services/api';
import { useAuth } from '../../../../../../hooks/auth';
import ContainerCrop from './containerCrop';
import Button from '../../../../../../newComponents/Button';

export interface IFile {
  id: string;
  empresa_id: number;
  product_id?: number;
  order: number | null;
  name: string;
  able: boolean;
  data_inclusao: Date;
  data_alteracao: Date;
  data_exclusao: Date | null;
  file?: Blob;
  preview: string;
  uploaded?: boolean;
  progress: boolean;
  error?: boolean;
}

export interface IUploadedFile {
  id: string;
  file?: Blob;
  empresa_id: number;
  product_id?: number;
  name: string;
  order: number | null;
  able: boolean;
  data_inclusao: Date;
  data_alteracao: Date;
  data_exclusao: Date | null;
}

export const Banner: React.FC = () => {
  const { addToast } = useToast();
  const { user } = useAuth();

  const [newFiles, setNewFiles] = useState([] as IFile[]);
  const [uploadedFiles, setUploadedFiles] = useState([] as IFile[]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalPage, setModalPage] = useState(1);
  const [modalEditOpen, setModalEditIsOpen] = useState(false);
  const [editFile, setEditFile] = useState<IFile | null>(null);
  const [uploadedFileEdit, setUploadedFileEdit] = useState<IFile | null>(null);

  const updateFile = (id: string, data: Partial<IFile>): void => {
    setUploadedFiles((prevState) => {
      return prevState.map((uploadedFile) => {
        let newFile = uploadedFile;

        if (id === uploadedFile.id) {
          newFile = { ...uploadedFile, ...data };
          delete newFile.file;
        }

        return id === uploadedFile.id ? newFile : uploadedFile;
      });
    });
  };

  const processUpload = (uploadedFile: IFile): void => {
    const data = new FormData();

    data.append('banner_img', uploadedFile.file!, uploadedFile.name);

    api
      .post(`/banner/${user.empresa_id}`, data, {
        headers: {
          'Content-Type': `multipart/form-data`,
        },
      })
      .then(({ data: _data }: { data: IUploadedFile }) => {
        const updatedFile = {
          ..._data,
          uploaded: true,
          progress: false,
          error: false,
          preview: `${process.env.REACT_APP_SERVER_URL}/files/${_data.name}`,
        };

        updateFile(uploadedFile.id, updatedFile);
      })
      .catch((err) => {
        console.log(err);

        const notUpdatedFile = {
          error: true,
          uploaded: false,
          progress: false,
          preview: '',
        };

        updateFile(uploadedFile.id, notUpdatedFile);
      });
  };

  const deleteImage = (id: string): void => {
    api
      .delete(`/banner/${id}`)
      .then(() => {
        addToast({
          type: 'success',
          title: 'Imagem apagada!',
        });
        setUploadedFiles((prevState) =>
          prevState.filter((file) => file.id !== id),
        );
      })
      .catch((err) => {
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro ao apagar a imagem. Tente novamente mais tarde.',
        });
      });
  };

  const handleBannerEnabled = (id: string): void => {
    const foundBanner = uploadedFiles.find((file) => file.id === id)!;
    const foundBannerIndex = uploadedFiles.findIndex((file) => file.id === id)!;

    const bannerEnabled = uploadedFiles.filter(
      (banner) => banner.able === true,
    );

    if (foundBanner.able === false && bannerEnabled.length >= 3) {
      addToast({
        type: 'error',
        title: 'Limite máx. 3 imagens ativadas atingido.',
      });
      return;
    }

    foundBanner.able = !foundBanner.able;

    setUploadedFiles((prevState) => {
      const banners = [...prevState];
      banners.splice(foundBannerIndex, 1, foundBanner);
      return banners;
    });
  };

  const handleUpload = (file: any, id: string): void => {
    let tamanho = Number(fileSize(file.size).split(' ')[0]);
    const unidade = fileSize(file.size).split(' ')[1];

    if (unidade === 'MB') {
      tamanho *= 1000;
    }
    if (tamanho > 3000) {
      addToast({
        type: 'error',
        title: `Imagem ${file.name} não foi adicionada. Ultrapassou o tamanho limite 3 MB.`,
      });
      return;
    }

    if (uploadedFiles.length + 1 > 10) {
      addToast({
        type: 'error',
        title: 'Limite máx. 10 imagens ultrapassado.',
      });
      return;
    }

    const uploadedNewFile = ({
      file,
      id: id,
      name: file.name,
      preview: URL.createObjectURL(file),
      uploaded: false,
      error: false,
      able: false,
      progress: true,
    } as IFile)

    setEditFile(uploadedNewFile);
    setModalEditIsOpen(true)
  };

  const handleUploadFiles = (files: any[]): void => {
    const uploadedNewFiles: IFile[] = files
      .filter((file) => {
        let tamanho = Number(fileSize(file.size).split(' ')[0]);
        const unidade = fileSize(file.size).split(' ')[1];

        if (unidade === 'MB') {
          tamanho *= 1000;
        }
        if (tamanho > 3000) {
          addToast({
            type: 'error',
            title: `Imagem ${file.name} não foi adicionada. Ultrapassou o tamanho limite 3 MB.`,
          });
          return false;
        }
        return true;
      })
      .map(
        (file, index: number) =>
          ({
            file,
            id: (
              uploadedFiles.reduce(
                (acc: number, cur: IFile) =>
                  Number(cur.id) > acc ? Number(cur.id) : acc,
                0,
              ) +
              1 +
              index
            ).toString(),
            name: file.name,
            preview: URL.createObjectURL(file),
            uploaded: false,
            error: false,
            able: false,
            progress: true,
          } as IFile),
      );

    if (uploadedFiles.length + uploadedNewFiles.length > 10) {
      addToast({
        type: 'error',
        title: 'Limite máx. 10 imagens ultrapassado.',
      });
      return;
    }

    setNewFiles((prevState) => [...prevState, ...uploadedNewFiles]);
  };

  const saveImageCroped = (): void => {
    setUploadedFiles((prevState) => [...prevState, ...newFiles]);
    setNewFiles([]);
    setModalPage(1);
    setModalIsOpen(false);
  };

  const updateBanners = async (
    _uploadedFiles: IUploadedFile[],
  ): Promise<void> => {
    // eslint-disable-next-line no-param-reassign
    _uploadedFiles = _uploadedFiles.map(
      (file, index: number, arr: IUploadedFile[]) => {
        if (file.order) {
          return file;
        }

        // eslint-disable-next-line no-param-reassign
        file.order =
          arr.reduce((acc: number, cur: IUploadedFile) => {
            return cur.order && cur?.order > 0 ? cur.order : acc;
          }, 0) + 1;

        return file;
      },
    );
    api
      .put(`/banner/${user.empresa_id}`, { banners: _uploadedFiles })
      .then(({ data }) => {
        setUploadedFiles((oldState) =>
          oldState.map((banner) => {
            return {
              ...banner,
              ...data.banners.find((item: any) => item.id === banner.id),
            };
          }),
        );
        addToast({
          type: 'success',
          title: 'Alterações salvas!',
        });
      })
      .catch((err) => console.log(err));
  };

  const processUpdateBanner = async (
    _uploadedFile: IUploadedFile,
  ): Promise<void> => {
    const data = new FormData();
    data.append('banner_img', _uploadedFile.file!, _uploadedFile.name);

    api
      .patch(`/banner/${user.empresa_id}/${_uploadedFile.id}`, data, {
        headers: {
          'Content-Type': `multipart/form-data`,
        },
      })
      .then(({ data: _data }: { data: Partial<IUploadedFile> }) => {
        const updatedFile = {
          ..._data,
          uploaded: true,
          progress: false,
          error: false,
          preview: `${process.env.REACT_APP_SERVER_URL}/files/${_data.name}`,
        };

        updateFile(_uploadedFile.id, updatedFile);
        addToast({
          type: 'success',
          title: 'Imagem alterada!',
        });
      })
      .catch((err) => {
        console.log(err);
        addToast({
          type: 'error',
          title: 'Erro. Tente novamente mais tarde',
        });
      });
  };

  useEffect(() => {
    api
      .get(`/banner/${user.empresa_id}`)
      .then(({ data }) => {
        const normalizeFilesUploaded: IFile[] = data.banners.map(
          (file: IUploadedFile) => {
            return {
              ...file,
              preview: `${process.env.REACT_APP_SERVER_URL}/files/${file.name}`,
              progress: false,
              error: false,
              uploaded: true,
            } as IFile;
          },
        );
        setUploadedFiles(normalizeFilesUploaded);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [user.empresa_id]);

  useEffect(() => {
    const fileNotUploaded = uploadedFiles.find(
      (file) => file.uploaded === false && file.error === false,
    );

    if (fileNotUploaded) {
      processUpload(fileNotUploaded);
    }
  }, [uploadedFiles]);

  useEffect(() => {
    if (newFiles.length) {
      setModalIsOpen(true);
    }
  }, [newFiles]);

  useEffect(() => {
    if (newFiles.length > 0 && modalPage > newFiles.length) {
      saveImageCroped();
    }
  }, [modalPage, newFiles.length]);

  const changeToNewFileCroped = (file: any): void => {
    const newFilesList = [...newFiles];
    const foundImageIndex = newFilesList.findIndex(
      (newFile) => newFile.id === file.id,
    )!;
    newFilesList.splice(foundImageIndex, 1, file);
    setNewFiles(newFilesList);
    setModalPage((prevState) => prevState + 1);
  };

  const Conteudo: React.FC = () => {
    if (modalPage <= newFiles.length) {
      return (
        <ContainerCrop
          isFirst={modalPage >= newFiles.length}
          file={newFiles[modalPage - 1]}
          changeToNewFileCroped={changeToNewFileCroped}
        />
      );
    }
    return <div />;
  };

  const handleSortProducts = (products: IFile[]): void => {
    setUploadedFiles(products);
  };

  const changeToEditFileCroped = (_file: any): void => {
    setUploadedFileEdit(_file);
    setEditFile(null);
    setModalEditIsOpen(false);
  };

  useEffect(() => {
    if (uploadedFileEdit) {
      processUpdateBanner(uploadedFileEdit);
    }
  }, [uploadedFileEdit]);

  return (
    <S.Container>
      <S.PageTitle>Imagens para o banner da loja</S.PageTitle>

      {uploadedFiles.some((file) => file.able === true) ? (
        <CustomCarousel
          paddingTop="30%"
          images={uploadedFiles
            .filter((file) => file.able === true)
            .map((file) => file.preview)}
        />
      ) : (
        <S.SemBannerTitle>
          <p>Sem imagens ativadas.</p>
        </S.SemBannerTitle>
      )}

      <div>
        <S.Subtitle>Banners</S.Subtitle>

        <S.InfoBanner>
          <p>
            Você pode adicionar, substituir ou remover imagens do banner da loja
          </p>

          <S.ContentBanner>
            <Upload onUpload={handleUploadFiles} />
            {loading ? (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Load />
              </div>
            ) : (
              <FileList
                files={uploadedFiles}
                onSelectFile={handleUpload}
                setUploadedFiles={setUploadedFiles}
                handleBannerEnabled={handleBannerEnabled}
                onDelete={deleteImage}
                processUpload={processUpload}
                onSortProducts={(file) => handleSortProducts(file)}
              />
            )}

            <Button
              style={{ marginTop: '12px' }}
              variant="outlined"
              type="button"
              onClick={() => updateBanners(uploadedFiles)}
            >
              Salvar
            </Button>
          </S.ContentBanner>

          <h3>Observação</h3>
          <ul className="observation">
            <li>Você pode adicionar até 10 imagens.</li>
            <li>Você pode mostrar até 3 imagens no banner por vez.</li>
            <li>Cada imagem terá o tamanho máx. de 3 MB</li>
          </ul>
        </S.InfoBanner>
      </div>

      {/* Adição de banner */}
      <Modal
        open={modalIsOpen}
        onClose={() => {
          setModalIsOpen(false);
          setNewFiles([]);
        }}
        closeAfterTransition
      >
        <Slide direction="up" in={modalIsOpen} mountOnEnter unmountOnExit>
          <Box
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <S.ModalContainer>
              <h1>Ajustes</h1>
              <button
                type="button"
                className="closeModal"
                onClick={() => {
                  setModalIsOpen(false);
                  setModalPage(1);
                  setNewFiles([]);
                }}
              >
                X
              </button>
              <S.LineDividerStyled />

              <S.ModalContainerConteudo>
                {!(modalPage > newFiles.length) && <Conteudo />}
              </S.ModalContainerConteudo>
            </S.ModalContainer>
          </Box>
        </Slide>
      </Modal>

      {/* Edição de banner */}
      <Modal
        open={modalEditOpen}
        onClose={() => {
          setModalEditIsOpen(false);
          setEditFile(null);
        }}
        closeAfterTransition
      >
        <Slide direction="up" in={modalEditOpen} mountOnEnter unmountOnExit>
          <Box
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <S.ModalContainer>
              <h1>Ajustes</h1>
              <button
                type="button"
                className="closeModal"
                onClick={() => {
                  setModalEditIsOpen(false);
                  setEditFile(null);
                }}
              >
                X
              </button>
              <S.LineDividerStyled />

              <S.ModalContainerConteudo>
                {
                  editFile && (
                    <ContainerCrop
                      isFirst={!!editFile}
                      file={editFile}
                      changeToNewFileCroped={changeToEditFileCroped}
                    />
                  )
                }
              </S.ModalContainerConteudo>
            </S.ModalContainer>
          </Box>
        </Slide>
      </Modal>
    </S.Container>
  );
};
